import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { BaseComponent } from '../classes/BaseComponent';
import { Router } from '@angular/router';
import { Global } from '../classes/Global';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent extends BaseComponent implements OnInit {

  @Output() onBurgerClicked = new EventEmitter();

  constructor(
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
  }

  getGooglePlayImageUrl(): string {
    let language = InternationalizationHelper.getTwoCharactersLanguage();
    return "./assets/images/get_it_on_google_play_" + language + ".png";
  }

  getAppStoreImageUrl(): string {
    let language = InternationalizationHelper.getTwoCharactersLanguage();
    return "./assets/images/download_on_the_app_store_" + language + ".svg";
  }

  burgerClicked() {
    this.onBurgerClicked.emit();
  }

  searchClicked(obj){
    if (obj && obj.itemType != "" && obj.query != "") {
      this.router.navigate([ "/" + Global.getCountry() + "/search", { q: encodeURIComponent(obj.query), t: obj.itemType}]);
    }
  }

}
